import { Navigate } from 'react-router-dom';

/**
 * Legacy route: password reset now uses OTP on /forgot-password/confirm (see auth_routes.md).
 */
const ResetPassword = () => <Navigate to="/forgot-password" replace />;

export default ResetPassword;
